"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLEiBeaconBuilder = exports.BLEiBeacon = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@openhps/core");
const BLEUUID_1 = require("./BLEUUID");
const MACAddress_1 = require("./MACAddress");
const BLEBeaconObject_1 = require("./BLEBeaconObject");
const BufferUtils_1 = require("../utils/BufferUtils");
/**
 * BLE iBeacon Data Object
 * @see {@link https://wiki.aprbrother.com/en/iBeacon_Packet.html}
 */
let BLEiBeacon = class BLEiBeacon extends BLEBeaconObject_1.BLEBeaconObject {
    constructor(address, scanData) {
        super(address);
        if (scanData) {
            this.parseAdvertisement(scanData);
        }
    }
    computeUID() {
        let uid = new TextDecoder().decode(this.proximityUUID.toBuffer());
        uid = (0, BufferUtils_1.toHexString)((0, BufferUtils_1.concatBuffer)(this.proximityUUID.toBuffer(), Uint8Array.from([this.major]), Uint8Array.from([this.minor])));
        return uid;
    }
    isValid() {
        return this.proximityUUID !== undefined && this.major !== undefined && this.minor !== undefined;
    }
    parseManufacturerData(manufacturer, manufacturerData) {
        super.parseManufacturerData(manufacturer, manufacturerData);
        if (!manufacturerData) {
            return this;
        }
        const view = new DataView(manufacturerData.buffer, 0);
        if (manufacturer !== 0x004c ||
            manufacturerData.byteLength < 23 ||
            !(0, BufferUtils_1.arrayBuffersAreEqual)(manufacturerData.buffer.slice(0, 2), Uint8Array.from([0x02, 0x15]).buffer)) {
            return this;
        }
        this.proximityUUID = BLEUUID_1.BLEUUID.fromBuffer(manufacturerData.slice(2, 18));
        this.major = view.getUint16(18, false);
        this.minor = view.getUint16(20, false);
        this.calibratedRSSI = view.getInt8(22);
        if (this.uid === undefined) {
            this.uid = this.computeUID();
        }
        return this;
    }
};
exports.BLEiBeacon = BLEiBeacon;
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Number)
], BLEiBeacon.prototype, "major", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Number)
], BLEiBeacon.prototype, "minor", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", BLEUUID_1.BLEUUID)
], BLEiBeacon.prototype, "proximityUUID", void 0);
exports.BLEiBeacon = BLEiBeacon = tslib_1.__decorate([
    (0, core_1.SerializableObject)(),
    tslib_1.__metadata("design:paramtypes", [MACAddress_1.MACAddress, Uint8Array])
], BLEiBeacon);
/**
 * BLE iBeacon builder
 */
class BLEiBeaconBuilder extends BLEBeaconObject_1.BLEBeaconBuilder {
    constructor() {
        super();
        this.beacon = new BLEiBeacon();
        this.beacon.proximityUUID = BLEUUID_1.BLEUUID.fromString(core_1.UUID.generate().toString());
        this.beacon.major = 0;
        this.beacon.minor = 0;
    }
    static create() {
        return new BLEiBeaconBuilder();
    }
    static fromBeacon(beacon) {
        const builder = new BLEiBeaconBuilder();
        builder.beacon = beacon;
        return builder;
    }
    proximityUUID(uuid) {
        this.beacon.proximityUUID = uuid;
        return this;
    }
    major(major) {
        this.beacon.major = major;
        return this;
    }
    minor(minor) {
        this.beacon.minor = minor;
        return this;
    }
    build() {
        return new Promise((resolve) => {
            // Compute manufacturer data
            const manufacturerData = new DataView(new ArrayBuffer(23), 0);
            // Advertisement data
            manufacturerData.setUint8(0, 0x02); // Beacon code
            manufacturerData.setUint8(1, 0x15);
            // Proximity UUID
            const proximityUUID = new DataView(this.beacon.proximityUUID.toBuffer().buffer, 0);
            for (let i = 2; i < 2 + 16; i++) {
                manufacturerData.setUint8(i, proximityUUID.getUint8(i - 2));
            }
            manufacturerData.setUint16(18, this.beacon.major);
            manufacturerData.setUint16(20, this.beacon.minor);
            manufacturerData.setInt8(22, this.beacon.calibratedRSSI); // Calibrated RSSI
            this.beacon.manufacturerData.set(0x004c, new Uint8Array(manufacturerData.buffer));
            this.beacon.uid = this.beacon.computeUID();
            resolve(this.beacon);
        });
    }
}
exports.BLEiBeaconBuilder = BLEiBeaconBuilder;
//# sourceMappingURL=BLEiBeacon.js.map